import { render, staticRenderFns } from "./comment-badge.vue?vue&type=template&id=5719c209"
import script from "./comment-badge.vue?vue&type=script&lang=js"
export * from "./comment-badge.vue?vue&type=script&lang=js"
import style0 from "./comment-badge.vue?vue&type=style&index=0&id=5719c209&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports